import CustomStatisticalControlBatchDetail from '../../components/CustomStatisticalControlBatchDetail';

const StatisticalControlBatchDetail = () => {
  return <CustomStatisticalControlBatchDetail normative="coe" />;
};

export default StatisticalControlBatchDetail;
